import { render, staticRenderFns } from "./SigninLayout.vue?vue&type=template&id=53cbf24a&scoped=true"
import script from "./SigninLayout.vue?vue&type=script&lang=js"
export * from "./SigninLayout.vue?vue&type=script&lang=js"
import style0 from "./SigninLayout.vue?vue&type=style&index=0&id=53cbf24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cbf24a",
  null
  
)

export default component.exports